import React, { Component } from "react";
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import showdown from 'showdown';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Layout from '../Layout/Layout';
import * as actions from '../../../actions/'; 

import style from './Assertion.scss';
import classes from '../../../utils/cssClasses';
import Loading from '../../Loading';



class BadgeClass extends Component{

	componentDidMount(){
		this.props.fetchBadgeClass(this.props.match.params.badgeId);
		this.props.fetchAssertion(this.props.match.params.id);
	}

	printMarkDown(string){
		var converter = new showdown.Converter();
		return converter.makeHtml(string);
	}
	
	printName(assertion){
		return assertion.name ? assertion.name : assertion.recipient.email;
	}

	render(){
		console.log("assertion");
		const {badgeClass, assertion} = this.props;
		if (badgeClass === null || assertion === null){
			return (
				<Layout>
					<Loading />
				</Layout>
				);
		}
		const headerBg = {
			backgroundImage: `url(/api/image/${badgeClass.hero_image})`
		};
		


		return(
			<Layout container="container-fluid">
				<main className={classes('badge-class-container',style)}>
					<header
						className={classes('badge-header',style)}
						style={headerBg}
						>
						<hgroup className={classes('container',style)}>
							<hgroup className={classes('row align-items-end',style)}>
								<hgroup className={classes('col-12 col-md-auto text-center image-head-view',style)}>
									<img src={`/api/image/${badgeClass.image}`} alt=""/>
								</hgroup>
								<hgroup className={classes('col-12 col-md')}>
									<div className={classes('row align-items-center')}>
										<div className={classes('col-12 col-md-6 text-center text-md-left',style)}>
											<h2 className={classes('text-light text-title',style)}>
												{ badgeClass.name }
												<small><Link to={`/badgeClasses/${BadgeClass._id}`}> Badge details </Link></small>
											</h2>
										</div>
										<div className={classes('col-12 col-md-6 text-center text-md-right',style)}>
											<h2 className={classes('text-light',style)}>Learner: {this.printName(assertion)} </h2>
										</div>
									</div>
								</hgroup>
							</hgroup>
						</hgroup>
					</header>

					<section className={classes('container badge-content',style)}>
						<div className={classes('row',style)}>
							<div className={classes('col-12 col-md-9 badge-content-primary',style)}>
								<div className={classes('card card-light',style)}>
									{assertion.narrative ? (
										<div className={classes('card-header',style)}>
											<b>Assertion narrative</b>
										</div>
									) : ''}
									<div className={classes('card-body',style)}>
										{assertion.narrative ? (
											<p
												dangerouslySetInnerHTML={{__html: this.printMarkDown(assertion.narrative)}} />
										) : ''}
										<p className={classes('mt-5 small',style)}>
											Download:
										</p>
										<p className={classes('small',style)}>
											<span style={{
												marginRight: '42px'
											}}> v1.1</span>
											<a target="_blank" href={`/api/json/v1/assertion/${this.props.match.params.id}`} style={{
												marginRight: '40px'
											}}>
												Json
											</a> 
											<a target="_blank" href={`/api/image/v1/assertion/${this.props.match.params.id}`} style={{
												marginRight: '40px'
											}}>
												Baked Image
											</a>
										</p>
										<p className={classes('mt-3 small',style)}>
											<span style={{
												marginRight: '40px'
											}}>
												v2.0
											</span>
											<a target="_blank" href={`/api/json/v2/assertion/${this.props.match.params.id}`} style={{
												marginRight: '40px'
											}}>
												Json
											</a> 
											<a target="_blank" href={`/api/image/v2/assertion/${this.props.match.params.id}`} style={{
												marginRight: '40px'
											}}>
												Baked image
											</a>
										</p>
									</div>
								</div>
							</div>
							{assertion.expires !== undefined || assertion.revoked ? (
								<div className={classes('col-12 col-md-3 badge-content-primary')}>
									<div className={classes('card',style)}>
										<div className={classes('card-header',style)}>
											<b>Expiration</b>
										</div>
										<div className={classes('card-body',style)}>
											{ assertion.expires !== undefined ? (
												<p>
													This assertion will expire on {assertion.expires.toLocaleString().split('T')[0]}
												</p>
											) : '' }
											{ assertion.revocationReason ? (
												<p>
													This assertion is <b>revoked</b>.
												</p>

											) : '' }
											{ assertion.revokedReason ? (
												<p>
													The reason is:  <br/>
													<span
														dangerouslySetInnerHTML={{__html: this.printMarkDown(assertion.revokedReason)}} />
												</p>
											) : '' }
										</div>
									</div>
								</div>
							) : ''}
						</div>
						<hr/>
						{ assertion.evidence.length ?
							(<div className={classes('row row-badge-content',style)}>
								<div className={classes('col-12',style)}>
									<div className={classes('card card-light',style)}>
										<h5><b>Evidence{assertion.evidence.length > 1 ? 's':''}</b></h5>
										{ assertion.evidence.map(evidence => (
											<div 
												key={evidence._id}
												className={classes('card mt-4',style)}
											>
												<header className={classes('card-header',style)}>
													<div className={classes('row align-items-end',style)}>
														{evidence.name ? (
															<div className={classes('col',style)}>
																<h5 className={classes('mb-0',style)}><b>{evidence.name}</b></h5>
															</div>
														) : ''}
														<div className={classes('col-auto',style)}>
															<a target="_blank" className={classes('text-primary')} href={evidence.id}>
				    										<FontAwesomeIcon className={classes('mr-2')} icon="link" />
																Documentation Url
															</a>
														</div>
														{evidence.genre ? (
														<div className={classes('col-auto',style)}>
															<b>Genre: </b>{evidence.genre}
														</div>
														) : ''}
														{evidence.audience ? (
														<div className={classes('col-auto',style)}>
															<b>Audience: </b>{evidence.audience}
														</div>
														) : ''}
													</div>
												</header>
												{evidence.narrative || evidence.description ? (
													<div className={classes('card-body',style)}>
														<p
															dangerouslySetInnerHTML={{__html: this.printMarkDown(evidence.narrative)}} />
														<p
															dangerouslySetInnerHTML={{__html: this.printMarkDown(evidence.description)}} />
													</div>
												): ''}
											</div>
											)) }
									</div>
								</div>
							</div>) : ''
						}
					</section>
				</main>
			</Layout>
		);
	}
}

function mapStateToProps({badgeClass,assertion}){
	return {badgeClass,assertion};
}

export default connect(mapStateToProps,actions)(BadgeClass)


// WEBPACK FOOTER //
// ./src/components/Frontend/Assertion/Assertion.js